import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Grid, Button } from '@mui/material';
import XDateRange from "../extra/XDateRange";
import dayjs from "dayjs";

export default function Form({
  title,
  companies = [],
  projects = [],
  cameras = [],
  defaultValues = {},
  onSubmit = (data) => { },
  onChange = (column, data) => { },
  back = () => { }
}) {
  const [selectedCam, setSelectedCam] = React.useState({});
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: defaultValues,
    mode: "all"
  });

  // Trigger onChange when company or project changes
  React.useEffect(() => {
    onChange("company", watch("company"));
  }, [watch("company")]);

  React.useEffect(() => {
    onChange("project", watch("project"));
  }, [watch("project")]);

  const cameraId = watch("camera");

  React.useEffect(() => {
      setSelectedCam(cameras.find((camera) => camera.id == cameraId) || {});
  }, [cameraId, cameras]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ p: 3 }}>
        {title && (
          <Typography variant="h5" align="center" gutterBottom>
            {title}
          </Typography>
        )}

        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
              <select>
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>
                    {company.company_name}
                  </option>
                ))}
              </select>
            </RFG>
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>

            <RFG name="project" label="Project Name" control={control} rules={{ required: true }} className="mb-2">
              <select>
                <option value="">Select Project</option>
                {projects.map((project) => (
                  <option key={project.id} value={project.id}>
                    {project.project_name}
                  </option>
                ))}
              </select>
            </RFG>
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>

            <RFG name="camera" label="Camera Name" control={control} rules={{ required: true }} className="mb-2">
              <select>
                <option value="">Select Camera</option>
                {cameras.map((camera) => (
                  <option key={camera.id} value={camera.id}>
                    {camera.camera_name}
                  </option>
                ))}
              </select>
            </RFG>
            {selectedCam?.id && (
              <Typography sx={{ fontSize: 12, textAlign: 'left' }}>
                Images available from:<br />
                {selectedCam?.first_image_time 
                  ? `${dayjs(selectedCam.first_image_time).format('DD-MMM-YYYY hh:mm:ss')} to ${dayjs(selectedCam.latest_image_time).format('DD-MMM-YYYY hh:mm:ss')}` 
                  : "No image dates found"}
              </Typography>
            )}
          </Grid>

          {/* Right Column */}
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>

            <RFG
              name="name"
              label="Name"
              control={control}
              rules={{
                required: true, maxLength: 500, pattern: {
                  value: /^[A-Za-z0-9\s\-_.]+$/,
                  message: "Invalid name. Allowed: letters, numbers, spaces, - _ .",
                }, maxLength: {
                  value: 200,
                  message: `Cannot exceed 200 characters`,
                }
              }}
              className="mb-2"
            >
              <input autoComplete="off" placeholder="Name" />
            </RFG>
          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>

            <XDateRange
              onChange={(start, end) => {
                setValue("date_from", start);
                setValue("date_to", end);
              }}
            />

          </Grid>
          <Grid size={{ xs: 12, sm: 4, md: 4 }}>
            <RFG
              name="video_duration"
              label="Video Duration"
              control={control}
              rules={{
                required: true, maxLength: 12,
                pattern: {
                  value: /^[0-9]{1,4}$/,
                  message: "Days must be in digits",
                },
                maxLength: {
                  value: 4,
                  message: `Cannot exceed 4 digits`
                }
              }}
              className="mb-2"
            >
              <input autoComplete="off" placeholder="Video Duration in seconds" />
            </RFG>

            <Box textAlign="right" sx={{ my: 4 }}>
              <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                Back
              </Button>
              <Button sx={{ mx: 2 }} className="btn-primary" type="submit">Save</Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}
